import { render, staticRenderFns } from "./ProgramInfos.vue?vue&type=template&id=05ccc328&"
import script from "./ProgramInfos.vue?vue&type=script&lang=ts&"
export * from "./ProgramInfos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports